export const ID_PROCESSING = "PROCESSING";
export const ID_COMPLETED = "PUBLISHED";
export const ID_ERROR = "ERROR";